<template>
  <cx-select
    v-if="options && options.quoteFrom === 'cxSelect'"
    @changeSelect="switchContent"
    :myid="myid"
    :datas="selectLists"
    :options="options"
  >
  </cx-select>
  <div
    class="tabsContainer scroller"
    ref="tabs"
    :style="getStyle"
    v-else-if="!options.isHide"
    :class="{ hideScrollBar_AutoScroll: options.tabAutoChange && !showTabsScorll, 'nowrap': nowrap }"
  >
    <div
      v-for="(tab, index) in tabLists"
      v-show="!tab.isHide"
      :key="index"
      ref="tab"
      class="tab"
      :class="activeIndex == index ? 'active' : ''"
      :style="{...sameStyle, ...getTabsStyle(index)}"
      @mouseenter.stop.self="mouseoverEv(index)"
      @mouseleave.stop.self="mouseLeaveEv(index)"
      @dblclick.stop="dbEditContent($event, index)"
      @click="switchContent(index)"
    >
      <template v-if="isInLayoutTabs">
        <div class="inline vertical-middle" v-if="getShowIcon && getIconPosition == 'left'">
          <img v-if="getBackIcon(tab, index)" :src="getBackIcon(tab, index)" :style="getIconImgStyle" />
          <cxTabsIcon
            v-else-if="getItemIconType(tab,index) === 'icon' && getItemIconSrc(tab,index)"
            :iconStyle="getIconStyle"
            :iconSrc="getItemIconSrc(tab,index)"
          ></cxTabsIcon
          ><!-- 单独设置图标 -->
          <img
            v-else-if="getItemIconType(tab,index) === 'img' && getItemIconSrc(tab,index)"
            :src="getItemIconSrc(tab,index)"
            :style="getIconImgStyle"
          /><!-- 单独设置图片 -->
          <cxIcon v-else-if="iconType === 'icon' && iconSrc" :options="options" :iconStyle="getIconStyle"></cxIcon>
          <img v-else-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
        </div>
        <div v-if="getShowIcon && getIconPosition == 'top'">
          <img v-if="getBackIcon(tab, index)" :src="getBackIcon(tab, index)" :style="getIconImgStyle" />
          <cxTabsIcon
            v-else-if="getItemIconType(tab,index) === 'icon' && getItemIconSrc(tab,index)"
            :iconStyle="getIconStyle"
            :iconSrc="getItemIconSrc(tab,index)"
          ></cxTabsIcon
          ><!-- 单独设置图标 -->
          <img
            v-else-if="getItemIconType(tab,index) === 'img' && getItemIconSrc(tab,index)"
            :src="getItemIconSrc(tab,index)"
            :style="getIconImgStyle"
          /><!-- 单独设置图片 -->
          <cxIcon v-else-if="iconType === 'icon' && iconSrc" :options="options" :iconStyle="getIconStyle"></cxIcon>
          <img v-else-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
        </div>
        <input
          class="edit-input"
          type="text"
          v-if="isEditStatus && editIndex === index"
          v-model="tab.name"
          @blur="dbChangeContent($event, index)"
        />
        <div class="tab-name inline" v-else>
          <span v-if="contentHasLimitwords">
            {{ tab.name.slice(0, textLimitLines) }}<span v-if="tab.name.length > textLimitLines">...</span>
          </span>
          <span :class="contentHasLimit && !contentHasLimitwords ? 'overflowHidMultiLines' : ''" :style="getTextLineLimit" v-else>{{ tab.name }}</span>
        </div>
        <div class="inline vertical-middle" v-if="getShowIcon && getIconPosition == 'right'">
          <img v-if="getBackIcon(tab, index)" :src="getBackIcon(tab, index)" :style="getIconImgStyle" />
          <cxTabsIcon
            v-else-if="tab.iconType === 'icon' && tab.iconSrc"
            :iconStyle="getIconStyle"
            :iconSrc="tab.iconSrc"
          ></cxTabsIcon
          ><!-- 单独设置图标 -->
          <img
            v-else-if="tab.iconType === 'img' && tab.iconSrc"
            :src="tab.iconSrc"
            :style="getIconImgStyle"
          /><!-- 单独设置图片 -->
          <cxIcon v-else-if="iconType === 'icon' && iconSrc" :options="options" :iconStyle="getIconStyle"></cxIcon>
          <img v-else-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
        </div>
        <div v-if="getShowIcon && getIconPosition == 'bottom'">
          <img v-if="getBackIcon(tab, index)" :src="getBackIcon(tab, index)" :style="getIconImgStyle" />
          <cxTabsIcon
            v-else-if="tab.iconType === 'icon' && tab.iconSrc"
            :iconStyle="getIconStyle"
            :iconSrc="tab.iconSrc"
          ></cxTabsIcon
          ><!-- 单独设置图标 -->
          <img
            v-else-if="tab.iconType === 'img' && tab.iconSrc"
            :src="tab.iconSrc"
            :style="getIconImgStyle"
          /><!-- 单独设置图片 -->
          <cxIcon v-else-if="iconType === 'icon' && iconSrc" :options="options" :iconStyle="getIconStyle"></cxIcon>
          <img v-else-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
        </div>
        <div
          v-if="(options.hoverBorderChecked && options.activeIndex == index) || (options.activeBorderChecked && hoverIndex == index)"
          :style="underlineStyle(index)"
          class="tab-underline"
        ></div>
        <!-- 分隔符 -->
        <div class="divide-box" v-if="index !== tabLists.length - 1 && options.showDivide" :style="getDivideStyle('img')">
          <span class="line" :style="getDivideStyle('line')" v-if="options.divideType !== 'custom'"></span>
          <cxIcon class="icon" v-if="divideIconType === 'icon' && options.divideType === 'custom'" :options="options" :iconStyle="getDivideStyle('icon')" iconSrcName="divideIconSrc"></cxIcon>
          <img class="icon" v-else-if="divideIconType === 'img' && divideIconSrc && options.divideType === 'custom'" :src="divideIconSrc" :style="getDivideStyle('img')" />
        </div>
      </template>
      <template v-else>
        <div class="inline" v-if="getShowIcon && getIconPosition == 'left'">
          <cxTabsIcon
            v-if="getItemIconType(tab,index) === 'icon' && getItemIconSrc(tab,index)"
            :iconStyle="getIconStyle"
            :iconSrc="getItemIconSrc(tab,index)"
          ></cxTabsIcon>
          <img
            v-else-if="getItemIconType(tab,index) === 'img' && getItemIconSrc(tab,index)"
            :src="getItemIconSrc(tab,index)"
            :darta-simh="getItemIconSrc(tab,index)"
            :style="getIconImgStyle"
          />
        </div>
        <div v-if="getShowIcon && getIconPosition == 'top'">
          <cxTabsIcon
            v-if="getItemIconType(tab,index) === 'icon' && getItemIconSrc(tab,index)"
            :iconStyle="getIconStyle"
            :iconSrc="getItemIconSrc(tab,index)"
          ></cxTabsIcon>
          <img
            v-if="getItemIconType(tab,index) === 'img' && getItemIconSrc(tab,index)"
            :src="getItemIconSrc(tab,index)"
            :darta-simh="getItemIconSrc(tab,index)"
            :style="getIconImgStyle"
          />
        </div>
        <input
          class="edit-input"
          type="text"
          v-if="isEditStatus && editIndex === index"
          v-model="tab.name"
          @blur="dbChangeContent($event, index)"
        />
        <div class="tab-name inline" v-else>
          <span v-if="contentHasLimitwords">
            {{ tab.name.slice(0, textLimitLines) }}<span v-if="tab.name.length > textLimitLines">...</span>
          </span>
          <span :class="contentHasLimit && !contentHasLimitwords ? 'overflowHidMultiLines' : ''" :style="getTextLineLimit" v-else>{{ tab.name }}</span>
        </div>
        <div class="inline" v-if="getShowIcon && getIconPosition == 'right'">
          <cxTabsIcon
            v-if="getItemIconType(tab,index) === 'icon' && getItemIconSrc(tab,index)"
            :iconStyle="getIconStyle"
            :iconSrc="getItemIconSrc(tab,index)"
          ></cxTabsIcon>
          <img
            v-if="getItemIconType(tab,index) === 'img' && getItemIconSrc(tab,index)"
            :src="getItemIconSrc(tab,index)"
            :darta-simh="getItemIconSrc(tab,index)"
            :style="getIconImgStyle"
          />
        </div>
        <div v-if="getShowIcon && getIconPosition == 'bottom'">
          <cxTabsIcon
            v-if="getItemIconType(tab,index) === 'icon' && getItemIconSrc(tab,index)"
            :iconStyle="getIconStyle"
            :iconSrc="getItemIconSrc(tab,index)"
          ></cxTabsIcon>
          <img
            v-if="getItemIconType(tab,index) === 'img' && getItemIconSrc(tab,index)"
            :src="getItemIconSrc(tab,index)"
            :darta-simh="getItemIconSrc(tab,index)"
            :style="getIconImgStyle"
          />
        </div>
        <div
          v-if="(options.hoverBorderChecked && options.activeIndex == index) || (options.activeBorderChecked && hoverIndex == index)"
          :style="underlineStyle(index)"
          class="tab-underline"
        ></div>
        <!-- 分隔符 -->
        <div class="divide-box" v-if="index !== tabLists.length - 1 && options.showDivide" :style="getDivideStyle('img')">
          <span class="line" :style="getDivideStyle('line')" v-if="options.divideType !== 'custom'"></span>
          <cxIcon class="icon" v-if="divideIconType === 'icon' && options.divideType === 'custom'" :options="options" :iconStyle="getDivideStyle('icon')" iconSrcName="divideIconSrc"></cxIcon>
          <img class="icon" v-else-if="divideIconType === 'img' && divideIconSrc && options.divideType === 'custom'" :src="divideIconSrc" :style="getDivideStyle('img')" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { isSsrPage } from "utils/index"
import eventMixin from "utils/event/eventMixin.js"
import plugins from "./plugin"
import cxSelect from "../../select/render/index"
import { findLayoutOptions } from "utils"
export default {
  mixins: [eventMixin, plugins],
  name: "cxTabs",
  components: { cxSelect },
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  created() {},
  computed: {
    //  获取当前操作的组件id
    ids() {
      return this.$store.state.states.activeID
    },
    showChangeWay() {
      return this.options?.pluginName?.includes("showTabsChangeWay")
    },
    tabLists() {
      let tabsList = this.options.tabsList
      // 针对以前iconSrc、iconType字段进行兼容
      // 需要先判断是否已经存在iconSrc、iconType字段，如果存在，则不再进行兼容处理
      if (tabsList && tabsList.length > 0 && (this.showChangeWay || !this.noCacheComponent)) {// 目前只有标签布局中需要单独设置，所以不用全部处理
        tabsList.forEach(item => {
          if (!item.hasOwnProperty("iconSrc")) {
            item.iconSrc = this.options.iconSrc ? this.options.iconSrc : ""
          }
          if (!item.hasOwnProperty("iconType")) {
            item.iconType = this.options.iconType ? this.options.iconType : ""
          }
          if (!item.hasOwnProperty("iconColor")) {
            item.iconColor = this.options.iconColor ? this.options.iconColor : ""
          }
          if (!item.hasOwnProperty("hoverIconSrc")) {
            item.hoverIconSrc = ""
          }
          if (!item.hasOwnProperty("hoverIconType")) {
            item.hoverIconType = ""
          }
          if (!item.hasOwnProperty("hoverIconColor")) {
            item.hoverIconColor = ""
          }
          if (!item.hasOwnProperty("activeIconSrc")) {
            item.activeIconSrc = ""
          }
          if (!item.hasOwnProperty("activeIconType")) {
            item.activeIconType = ""
          }
          if (!item.hasOwnProperty("activeIconColor")) {
            item.activeIconColor = ""
          }
        })
      }
      // 兼容处理完后需要将tabsList重新赋值给store中
      const param = {
        ...this.myid,
        option_name: "tabsList",
        option_val: tabsList
      }
      // this.$store.dispatch(this.request_prefix + "/changeOptions", param)
      this.$changeOptionsEV(tabsList, "tabsList", false)

      return tabsList
    },
    selectLists() {
      console.log("this.options.tabsList", this.options.tabsList)
      if (this.options.quoteFrom === "cxSelect") {
        let datas = []
        this.options.tabsList.forEach((item, index) => {
          datas.push({
            label: item.name,
            value: index,
            isHide: item.isHide
          })
        })
        return datas
      }
      return []
    },
    themeColor() {
      return isSsrPage() ? this.$store.state.page.themeColor : this.$store.state[this.request_prefix].page.themeColor
    },
    bgColor() {
      if (this.options.isShowBackgroundModel === "无背景") {
        return "none"
      }
      return this.$parseColor(this.options.bgColor, {
        isThemeColor: this.options.bgColorIsThemeColor
      })
      // return this.options.bgColorIsThemeColor
      //   ? this.themeColor
      //   : this.options.bgColor.color
      //   ? this.options.bgColor.color
      //   : this.options.bgColor
    },
    hoverBgColor() {
      if (this.options.isShowBackgroundModel === "无背景") {
        return "none"
      }
      return this.$parseColor(this.options.hoverBgColor, {
        isThemeColor: this.options.hoverBgColorIsThemeColor
      })
      // return this.options.hoverBgColorIsThemeColor
      //   ? this.themeColor
      //   : this.options.hoverBgColor.color
      //   ? this.options.hoverBgColor.color
      //   : this.options.hoverBgColor
    },
    borderColor() {
      // return this.options.borderIsThemeColor ? this.themeColor : this.options.borderColor
      return this.$parseColor(this.options.borderColor, {
        isThemeColor: this.options.borderIsThemeColor
      })
    },
    hoverBorderColor() {
      // return this.options.hoverBorderIsThemeColor ? this.themeColor : this.options.hoverBorderColor
      return this.$parseColor(this.options.hoverBorderColor, {
        isThemeColor: this.options.hoverBorderIsThemeColor
      })
    },
    activeIndex() {
      // 产品定的规则，支持外接数据源时不需要选中样式
      return this.options?.hasDataSource ? -1 : this.options.activeIndex
    },
    underlineStyle() {
      return function (index) {
        if (this.activeIndex == index || this.hoverIsSameActive) {
          return {
            borderTopWidth: this.options.hoverUnderlineWidth + "px",
            borderBottomWidth: 0,
            // borderColor: this.options.hoverUnderlineColor,
            borderColor: this.$parseColor(this.options.hoverUnderlineColor),
            borderStyle: this.options.hoverUnderlineStyle
          }
        } else {
          return {
            borderTopWidth: (this.options.hasOwnProperty("activeUnderlineWidth") ? this.options.activeUnderlineWidth : this.options.hoverUnderlineWidth) + "px",
            borderBottomWidth: 0,
            // borderColor: this.options.activeUnderlineColor || this.options.hoverUnderlineColor,
            borderColor: this.$parseColor(this.options.activeUnderlineColor || this.options.hoverUnderlineColor),
            borderStyle: this.options.activeUnderlineStyle || this.options.hoverUnderlineStyle
          }
        }
      }
    },
    hoverIsSameActive() {
      return this.options.hasOwnProperty("hoverIsSameActive") ? this.options.hoverIsSameActive : true
    },
    hoverBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.hoverBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("hoverBgColorIsThemeColor")
              ? this.options.hoverBgColorIsThemeColor
              : false,
            color: this.options.hoverBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    activeStyle() {
      let borderW = ""
      if (Array.isArray(this.options.hoverBorderWidth)) {
        this.options.hoverBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.hoverBorderWidth}px`
      }
      let activeBorderRadius = `${this.options.borderTopLeftRadius}px ${this.options.borderTopRightRadius}px ${this.options.borderBottomRightRadius}px ${this.options.borderBottomLeftRadius}px`
      if (this.options.hasOwnProperty('hoverBorderTopLeftRadius')) {
        activeBorderRadius = `${this.options.hoverBorderTopLeftRadius}px ${this.options.hoverBorderTopRightRadius}px ${this.options.hoverBorderBottomRightRadius}px ${this.options.hoverBorderBottomLeftRadius}px`
      }
      // 兼容以前的边框没有showHoverBorder属性取true
      let showHoverBorder = this.options.hasOwnProperty("showHoverBorder") ? this.options.showHoverBorder : true
      let padding = {}
      if(this.options.hasOwnProperty("hoverPadding") || this.options.hoverPaddingTypeFlag === 2){
        padding = {
          padding:this.getHoverPaddingStyle
        }
      }
      return {
        ...padding,
        ...this.hoverBgStyle,
        // color: this.options.hoverTextIsThemeColor
        //   ? this.themeColor
        //   : this.options.hoverColor.color
        //   ? this.options.hoverColor.color
        //   : this.options.hoverColor,
        color: this.$parseColor(this.options.hoverColor, {
          isThemeColor: this.options.hoverTextIsThemeColor
        }),
        // minWidth: this.options.widthAuto ? "" : this.options.tabWidth + "px",
        // height: this.options.hoverLineHeight + "px",
        "font-size": this.options.hoverFontSize + "px",
        "font-family": this.options.hoverFontFamily || "",
        "font-weight": this.options.hoverFontWeight,
        "text-align": this.options.hasOwnProperty("activeTextAlign") ? this.options.activeTextAlign : this.options.textAlign, // 为了兼容旧数据
        "font-style": this.options.hoverFontStyle,
        // "line-height":
        //   this.options.hoverLineHeightType === "%"
        //     ? this.options.hoverLineHeight + "%"
        //     : this.options.hoverLineHeight + "px",
        "line-height": this.options.hoverLineHeightType === '%' ? (this.options.hoverLineHeight / 100) :
            this.options.hoverLineHeightType === 'normal'? "normal" :this.options.hoverLineHeight + "px",
        "writing-mode": this.options.writingMode,
        "letter-spacing":
          this.options.letterSpacingType === "%"
            ? this.options.letterSpacing / 100 + "em"
            : this.options.letterSpacing + "px",
        "text-decoration": this.options.textDecoration,
        "text-indent": this.options.textIndent + "px",
        // "border-color": this.hoverBorderColor.color ? this.hoverBorderColor.color : this.hoverBorderColor,
        "border-color": this.$parseColor(this.hoverBorderColor),
        "border-style": this.options.hoverBorderStyle,
        "border-width": this.options.isShowBackgroundModel === "无背景" || !showHoverBorder ? "0px" : borderW,
        "border-radius": activeBorderRadius,
        // padding: this.getHoverPaddingStyle,
        // "border-top-left-radius":
        //   this.options.shapeType == "round"
        //     ? this.options.borderTopLeftRadius
        //     : this.options.borderTopLeftRadius + "px",
        // "border-top-right-radius":
        //   this.options.shapeType == "round"
        //     ? this.options.borderTopLeftRadius
        //     : this.options.borderTopRightRadius + "px",
        // "border-bottom-left-radius":
        //   this.options.shapeType == "round"
        //     ? this.options.borderTopLeftRadius
        //     : this.options.borderBottomLeftRadius + "px",
        // "border-bottom-right-radius":
        //   this.options.shapeType == "round"
        //     ? this.options.borderTopLeftRadius
        //     : this.options.borderBottomRightRadius + "px",
      }
    },
    activeBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.hoverIsSameActive || !this.options.activeBackground ? this.options.hoverBackground : this.options.activeBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("hoverBgColorIsThemeColor")
              ? this.options.hoverBgColorIsThemeColor
              : false,
            color: this.options.hoverBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    /* 悬浮样式 */
    hoverStyle() {
      if (this.hoverIsSameActive) return this.activeStyle
      let borderW = ""
      let activeBorderWidth = this.options.hasOwnProperty("activeBorderWidth") ? this.options.activeBorderWidth : this.options.hoverBorderWidth
      if (Array.isArray(activeBorderWidth)) {
        activeBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${activeBorderWidth}px`
      }
      let hoverBorderRadius = `${this.options.borderTopLeftRadius}px ${this.options.borderTopRightRadius}px ${this.options.borderBottomRightRadius}px ${this.options.borderBottomLeftRadius}px`
      if (this.options.hasOwnProperty('hoverBorderTopLeftRadius')) {
        hoverBorderRadius = `${this.options.hoverBorderTopLeftRadius}px ${this.options.hoverBorderTopRightRadius}px ${this.options.hoverBorderBottomRightRadius}px ${this.options.hoverBorderBottomLeftRadius}px`
      }
      if (this.options.hasOwnProperty('activeBorderTopLeftRadius')) {
        hoverBorderRadius = `${this.options.activeBorderTopLeftRadius}px ${this.options.activeBorderTopRightRadius}px ${this.options.activeBorderBottomRightRadius}px ${this.options.activeBorderBottomLeftRadius}px`
      }
      // let hoverLineHeight = this.options.hoverLineHeightType === "%" ? this.options.hoverLineHeight + "%" : this.options.hoverLineHeight + "px"
      let hoverLineHeight = this.options.hoverLineHeightType === '%' ? (this.options.hoverLineHeight / 100) :
          this.options.hoverLineHeightType === 'normal'? "normal" :this.options.hoverLineHeight + "px"
      if (this.options.hasOwnProperty('activeLineHeight')) {
        // hoverLineHeight = this.options.activeLineHeightType === "%" ? this.options.activeLineHeight + "%" : this.options.activeLineHeight + "px"
        hoverLineHeight = his.options.activeLineHeightType === '%' ? (this.options.activeLineHeight / 100) :
            this.options.activeLineHeightType === 'normal'? "normal" :this.options.activeLineHeight + "px"
      }
      // let hoverBorderColor = this.hoverBorderColor.color ? this.hoverBorderColor.color : this.hoverBorderColor
      let hoverBorderColor = this.$parseColor(this.hoverBorderColor)
      if (this.options.hasOwnProperty('activeBorderColor')) {
        // hoverBorderColor = this.options.activeBorderIsThemeColor ? this.themeColor : (this.options.activeBorderColor.color ? this.options.activeBorderColor.color : this.options.activeBorderColor)
        hoverBorderColor = this.$parseColor(this.options.activeBorderColor, {
          isThemeColor:  this.options.activeBorderIsThemeColor})
      }
      let showActiveBorder = this.options.hasOwnProperty("showActiveBorder") ? this.options.showActiveBorder : true
      let padding = {}
      if(this.options.hasOwnProperty("activePadding") || this.options.activePaddingTypeFlag === 2){
        padding = {
          padding:this.getActivePaddingStyle
        }
      }
      return {
        ...padding,
        ...this.activeBgStyle,
        // color: this.options.activeTextIsThemeColor
        //   ? this.themeColor
        //   : this.options.activeColor ? this.options.activeColor.color
        //   ? this.options.activeColor.color
        //   : this.options.activeColor : this.options.hoverColor,
        color: this.$parseColor(this.options.activeColor, {
          isThemeColor: this.options.activeTextIsThemeColor
        }),
        // minWidth: this.options.widthAuto ? "" : this.options.tabWidth + "px",
        // height: this.options.hoverLineHeight + "px",
        "font-size": (this.options.activeFontSize || this.options.hoverFontSize) + "px",
        "font-family": this.options.activeFontFamily || this.options.hoverFontFamily || "",
        "font-weight": this.options.activeFontWeight || this.options.hoverFontWeight,
        "text-align": this.options.hoverTextAlign || this.options.textAlign,
        "font-style": this.options.activeFontStyle || this.options.hoverFontStyle,
        "line-height": hoverLineHeight,
        "writing-mode": this.options.activeWritingMode || this.options.hoverWritingMode,
        "letter-spacing":
          this.options.letterSpacingType === "%"
            ? this.options.letterSpacing / 100 + "em"
            : this.options.letterSpacing + "px",
        "text-decoration": this.options.textDecoration,
        "text-indent": this.options.textIndent + "px",
        "border-color": hoverBorderColor,
        "border-style": this.options.activeBorderStyle || this.options.hoverBorderStyle,
        "border-width": !showActiveBorder ? "0px" : borderW,
        "border-radius": hoverBorderRadius,
        // padding: this.getActivePaddingStyle,
      }
    },
    defaultBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.defaultBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    defaultStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else if (this.options.borderWidth) {
        borderW += ` ${this.options.borderWidth}px`
      } else {
        borderW = "0px"
      }
      let showBorder = this.options.hasOwnProperty("showBorder") ? this.options.showBorder : true
      return {
        ...this.defaultBgStyle,
        // color: this.options.textIsThemeColor
        //   ? this.themeColor
        //   : this.options.color.color
        //   ? this.options.color.color
        //   : this.options.color,
        color: this.$parseColor(this.options.color, {
          isThemeColor: this.options.textIsThemeColor
        }),
        // minWidth: this.options.widthAuto ? "" : this.options.tabWidth + "px",
        // height: this.options.lineHeight + "px", // 暂时屏蔽固定高度
        "font-size": this.options.fontSize + "px",
        "font-family": this.options.fontFamily || "",
        "font-weight": this.options.fontWeight,
        "text-align": this.options.textAlign,
        "font-style": this.options.fontStyle,
        "line-height":
        this.options.lineHeightType === '%' ? (this.options.lineHeight / 100) :
            this.options.lineHeightType === 'normal'? "normal" :this.options.lineHeight + "px",
        "writing-mode": this.options.writingMode,
        "letter-spacing":
          this.options.letterSpacingType === "%"
            ? this.options.letterSpacing / 100 + "em"
            : this.options.letterSpacing + "px",
        "text-decoration": this.options.textDecoration,
        "text-indent": this.options.textIndent + "px",
        "border-radius": `${this.options.borderTopLeftRadius}px ${this.options.borderTopRightRadius}px ${this.options.borderBottomRightRadius}px ${this.options.borderBottomLeftRadius}px`,
        "border-style": this.options.borderStyle,
        // "border-color": this.borderColor.color ? this.borderColor.color : this.borderColor,
        "border-color": this.$parseColor(this.borderColor),
        "border-width": this.options.isShowBackgroundModel === "无背景" || !showBorder ? "0px" : borderW,
      }
    },
    getTabSize() {
      let maxWidth = this.options.showTabMaxWidth ? this.options.tabMaxWidth + "px" : ""
      let minWidth = this.options.showTabMinWidth ? this.options.tabMinWidth + "px" : this.options.widthAuto ? "" : this.options.tabWidth + "px"
      let maxHeight = this.options.showTabMaxHeight ? this.options.tabMaxHeight + "px" : ""
      let minHeight = this.options.showTabMinHeight ? this.options.tabMinHeight + "px" : ""
      // width初始时没有赋值是为了兼容以前的样式，因为以前的tabWidth是控制的最小宽度，只有重新设置了宽度才给width赋值
      let width = ""
      let widthUnit = ""
      let height = this.options.lineHeight
      let heightUnit = "px"
      const tabWidthType = this.options.tabWidthType
      switch (tabWidthType) {
        case "px":
          width = this.options.tabWidth
          widthUnit = "px"
          break
        case "自动":
          width = "auto"
          widthUnit = ""
          break
        case "%":
          widthUnit = "%"
          break
        default:
      }
      switch (this.options.tabHeightType) {
        case "px":
          height = this.options.tabHeight
          heightUnit = "px"
          break
        case "自动":
          height = "auto"
          heightUnit = ""
          break
        case "%":
          height = this.options.tabHeight
          heightUnit = "%"
          break
        default:
      }
      return {
        width: this.options.widthAuto || tabWidthType == "%" ? "" : width + widthUnit,
        height: height + heightUnit,
        minWidth: minWidth,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        minHeight: minHeight,
        flex: tabWidthType == "%" ? 1 : ""
      }
    },
    getTabPaddingStyle() {
      let padding = `${this.options.tabPadding}px`
      if (this.options.tabPaddingTypeFlag === 2) {
        padding = ` ${this.options.tabPaddingTop}px  ${this.options.tabPaddingRight}px  ${this.options.tabPaddingBottom}px  ${this.options.tabPaddingLeft}px`
      }
      return padding
    },
    sameStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.defaultBoxShadowH)) {
        this.options.defaultBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.defaultBoxShadowH[index]}px ${_this.options.defaultBoxShadowV ?
              _this.options.defaultBoxShadowV[index] : 0}px ${_this.options.defaultBoxShadowBlur ?
              _this.options.defaultBoxShadowBlur[index] : 0}px ${_this.options.defaultBoxShadowSpread ?
              _this.options.defaultBoxShadowSpread[index] : 0}px ${this.options.defaultBoxShadowColor ?
              _this.$parseColor(_this.options.defaultBoxShadowColor[index]) : ""}`
        })
      } else {
        tmpStyle +=
            `${this.options.defaultBoxShadowH}px ${this.options.defaultBoxShadowV}px ${this.options.defaultBoxShadowBlur}px ${this.options.defaultBoxShadowSpread}px ${this.$parseColor(this.options.defaultBoxShadowColor)}`
      }
      const divideWidth = this.options.divideWidth || 1
      let divideMargin = 0
      if (this.options.marginRight !== undefined) divideMargin = -(this.options.marginRight + divideWidth) / 2
      return {
        ...this.getTabSize,
        opacity: this.options.hasOwnProperty("tabOpacity") ? this.options.tabOpacity / 100 : 1,
        padding: this.getPaddingStyle,
        "margin-right": this.options.marginRight + "px",
        "--ultimate-Width": this.options.widthAuto ? "200px" : `${this.options.tabWidth + this.editInputPadding}px`,
        "margin-bottom": this.options.marginBottom + "px",
        "box-shadow": tmpStyle,
        "--divideMargin": divideMargin + "px",
      }
    },
    getTabsStyle() {
      return function (index) {
        if (index === this.activeIndex) {
          return this.activeStyle
        } else if (index === this.hoverIndex) {
          return this.hoverStyle
        } else {
          return this.defaultStyle
        }
      }
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("allBgColorIsThemeColor")
              ? this.options.allBgColorIsThemeColor
              : false,
            color: this.options.allBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle +=
              `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle +=
            `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getStyle() {
      let borderW = ""
      if (Array.isArray(this.options.allBorderWidth)) {
        this.options.allBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.allBorderWidth}px`
      }
      let padding = `${this.options.ulPadding}px`
      if (this.options.ulPaddingTypeFlag === 2) {
        padding = ` ${this.options.ulPaddingTop}px  ${this.options.ulPaddingRight}px  ${this.options.ulPaddingBottom}px  ${this.options.ulPaddingLeft}px`
      }
      let showAllBorder = this.options.hasOwnProperty("showAllBorder") ? this.options.showAllBorder : true
      return {
        ...this.bgStyle,
        opacity: this.options.opacity / 100,
        "box-shadow": this.boxShadowStyle,
        "border-top-left-radius": this.options.allBorderTopLeftRadius + "px",
        "border-top-right-radius": this.options.allBorderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.allBorderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.allBorderBottomLeftRadius + "px",
        "border-style": this.options.allBorderStyle,
        // "border-color": this.options.allBorderIsThemeColor ? this.themeColor : this.options.allBorderColor.color
        //   ? this.options.allBorderColor.color
        //   : this.options.allBorderColor,
        "border-color": this.$parseColor(this.options.allBorderColor, {
          isThemeColor: this.options.allBorderIsThemeColor
        }),
        "border-width": !showAllBorder ? "0px" : borderW,
        display: this.showTabsScorll || this.options.tabWidthType === "%" ? "flex" : "",
        "overflow-y": this.showTabsScorll ? "hidden" : "",
        "overflow-x": this.showTabsScorll ? "auto" : "",
        padding: padding,
      }
    },
    textLimitLines() {
      return this.options.textLimitLines
    },
    contentHasLimit() {
      return this.options.contentHasLimit
    },
    textLimitWords() {
      return this.options.textLimitWords || 1
    },
    // 判断是否按字数限制
    contentHasLimitwords() {
      return this.contentHasLimit && (this.options.contentHasLimitRadio == "字数" || !this.options.contentHasLimitRadio)
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      this.editInputPadding = this.options.padding * 2
      if (this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
        this.editInputPadding = this.options.paddingRight + this.options.paddingLeft
      }
      return padding
    },
    getHoverPaddingStyle() {
      let hoverPadding = `${this.options.hoverPadding}px`
      if (this.options.hoverPaddingTypeFlag === 2) {
        hoverPadding = `${this.options.hoverPaddingTop}px ${this.options.hoverPaddingRight}px ${this.options.hoverPaddingBottom}px ${this.options.hoverPaddingLeft}px`
      }
      return hoverPadding
    },
    getActivePaddingStyle() {
      let activePadding = `${this.options.activePadding}px`
      if (this.options.activePaddingTypeFlag === 2) {
        activePadding = `${this.options.activePaddingTop}px ${this.options.activePaddingRight}px ${this.options.activePaddingBottom}px ${this.options.activePaddingLeft}px`
      }
      return activePadding
    },
    iconSrc() {
      return this.options ? this.options.iconSrc : ""
    },
    iconType() {
      return this.options ? this.options.iconType : "img"
    },
    getIconPosition() {
      return this.options ? this.options.iconPosition || "left" : "left"
    },
    getShowIcon() {
      return this.options ? this.options.showIcon : "false"
    },
    getMargin() {
      console.log("getIconPosition", this.getIconPosition, this.options.iconPosition)
      const iconPosition = this.options.iconPosition ? this.options.iconPosition : "left"
      return iconPosition === "right"
        ? `0 0 0 ${this.options.iconMargin}px`
        : iconPosition === "left"
        ? `0 ${this.options.iconMargin}px 0 0`
        : iconPosition === "top"
        ? `0 0 ${this.options.iconMargin}px 0`
        : iconPosition === "bottom"
        ? `${this.options.iconMargin}px 0 0 0`
        : "0 0 0 0"
    },
    getIconStyle() {
      return {
        display: "inline-block",
        // "--color": this.options.iconColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.iconColor && this.options.iconColor.color
        //   ? this.options.iconColor.color
        //   : this.options.iconColor,
        "--color": this.$parseColor(this.options.iconColor, {
          isThemeColor: this.options.iconColorIsThemeColor
        }),
        width: this.options.hasOwnProperty("iconWidth") ? this.options.iconWidth + "px" : "14px",
        height: this.options.hasOwnProperty("iconHeight") ? this.options.iconHeight + "px" : "14px",
        margin: this.getMargin
      }
    },
    getIconImgStyle() {
      return {
        width: this.options.hasOwnProperty("iconWidth") ? this.options.iconWidth + "px" : "14px",
        height: this.options.hasOwnProperty("iconHeight") ? this.options.iconHeight + "px" : "14px",
        margin: this.getMargin
      }
    },
    showTabsScorll() {
      return this.options.hasOwnProperty("showTabsScorll") ? this.options.showTabsScorll : false
    },
    noCacheComponent() {
      const rectAttr = this.getRectAttribute.call(this, this.myid)
      return rectAttr.options.noCacheComponent
    },
    // 判断当前组件是否是嵌套在自由布局中使用
    isInLayoutTabs() {
      let isInLayoutTabs = false
      // container_id_0-rect_id_71-directionIndex_0-elementInLayoutId_3
      if (this.myid.hasOwnProperty("directionIndex") && this.myid.hasOwnProperty("elementInLayoutId")) {
        isInLayoutTabs = true
      }
      return isInLayoutTabs
    },
    isLoginEngineTab() {
      const parentRectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.myid, "rect")
      if (
        parentRectAttr &&
        parentRectAttr.options?.pluginName &&
        parentRectAttr.options?.pluginName[0] == "loginEngineComponentPlugin"
      ) {
        return true
      } else {
        return false
      }
    },
    divideIconSrc() {
      return this.options ? this.options.divideIconSrc : ""
    },
    divideIconType() {
      return this.options ? this.options.divideIconType : "icon"
    },
    getDivideStyle() {
      return function(type) {
        let style = {}
        // const color = this.options.divideIconColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.divideIconColor && this.options.divideIconColor.color
        //   ? this.options.divideIconColor.color
        //   : this.options.divideIconColor
        const color = this.$parseColor(this.options.divideIconColor, {
          isThemeColor: this.options.divideIconColorIsThemeColor
        })
        const width = this.options.divideWidth || 1
        const height = this.options.divideHeight || 24
        style = {
          width: width + "px",
          height: height + "px",
        }
        switch (type) {
          case "line":
            style = {
              ...style,
              backgroundColor: color
            }
            break
          case "icon":
            style = {
              ...style,
              "--color": color,
            }
            break
          case "img":
            break
        }
        return style
      }
    },
    nowrap() {// 开启自适应并且没有最大宽度时不允许换行
      const widthAuto = this.options?.tabWidth === "auto" || this.options?.widthAuto
      return widthAuto && !(this.options?.showTabMaxWidth && this.options?.tabMaxWidth)
    },
    getTextLineLimit() {
      if (this.contentHasLimit && !this.contentHasLimitwords) {
        return {
          "-webkit-line-clamp": this.textLimitWords
        }
      } else return {}
    },
    getItemIconType() {
      /* 有选中和悬浮图标时才返回 没有就返回默认 */
      return function (tab, index) {
        if (this.activeIndex == index && tab.activeIconType) return tab.activeIconType
        else if (this.hoverIndex == index && tab.hoverIconType && this.activeIndex !== index) return tab.hoverIconType
        else return tab.iconType
      }
    },
    getItemIconSrc() {
      /* 有选中和悬浮图标时才返回 没有就返回默认 */
      return function (tab, index) {
        if (this.activeIndex == index && tab.activeIconSrc) return tab.activeIconSrc
        else if (this.hoverIndex == index && tab.hoverIconSrc && this.activeIndex !== index) return tab.hoverIconSrc
        else return tab.iconSrc
      }
    },
    getBackIcon() {// 后台分类数据源的图标
      return function (tab, index) {
        if (this.hoverIndex == index || this.activeIndex == index) return tab.backActiveIconUrl
        else return tab.backIconUrl
      }
    },
    dataType() {
      // 1:本地数据 2：外接数据 3: 搜索数据
      return this.options.dataType || "1"
    },
    layoutOptions() {
      return findLayoutOptions(this, this.myid)
    },
    searchComponentPlugin() {
      return this.layoutOptions?.pluginName?.includes("searchComponentPlugin")
    },
    updateTimer() {
      if (!this.options.updateTimer) {
        this.$changeOptionsEV(600, "updateTimer", false)
        return 600 * 1000
      }
      return this.options.updateTimer * 1000
    },
    currentFiledMapping() {
      return this.options.currentFiledMapping || {}
    }
  },
  data() {
    return {
      isEditStatus: false,
      hoverIndex: undefined,
      editIndex: undefined,
      editInputPadding: 0, //双击编辑tab时的默认宽度
      animateReloadTimer: null, // 用于动画更新
      tabWidthList: [],
      reloadTimer: null,
      isFlag: false
    }
  },
  watch: {
    "options.tabAutoChange"(n, o) {
      this.getTabWidthList()
      this.animateReloadFn()
    },
    "options.autoChangeTime"(n, o) {
      this.animateReloadFn()
    },
    activeIndex: {
      handler(newVal, oldVal) {
        if (window.chartEventBus) {
          this.handleChartEvent(this.tabLists[newVal].name)
        }
        if (newVal !== oldVal && this.options.tabAutoChange) {
          this.scrollToSelected()
        }
      }
    },
    dataType(n, o) {
      if (n !== o && n === "3" && !this.isFlag) {
        this.watchSearchData()
      }
    }
  },
  mounted() {
    this.$initPlugin(this.options?.pluginName)
    this.animateReloadFn()
    if (this.isLoginEngineTab) {
      // 兼容旧数据 用于判断登录框的几种登录方式
      let tabsList = this.options.tabsList
      tabsList.forEach(item => {
        if (!item.loginWay) {
          switch (item.content) {
            case "手机号登录":
              item.loginWay = 1
              break
            case "扫码登录":
              item.loginWay = 2
              break
            case "机构账号登录":
              item.loginWay = 3
              break
            case "短信验证码登录":
              item.loginWay = 4
              break
          }
        }
      })
      this.$changeOptionsEV(tabsList, "tabsList", false)
    }
    if (this.options.tabAutoChange) {
      this.getTabWidthList()
    }
    if (this.options?.noCacheComponent && this.options.appId && this.dataType !== "3") {
      this.updateData()
      if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
        this.reloadTimer = setInterval(() => this.updateData(), this.updateTimer)
      }
    }
    if (this.dataType === "3") {
      this.watchSearchData()
    }
  },
  methods: {
    watchSearchData() {
      this.isFlag = true
      this.$eventBus.$on(`searchDataUpdate-${this.myid.container_id}-${this.myid.rect_id}`, (data)=> {
        console.log('searchFastLinkData :>>',data);
        const  {type , fastLink} = data
        if (type === 1) {
          this.setFaskLinkData(fastLink)
        }
      })
    },
    mouseoverEv(index) {
      let _this = this
      this.hoverIndex = index
      const styleObj = this.activeStyle
      Object.keys(styleObj).forEach(key => {
        // _this.$refs.tab[index].style[key] = styleObj[key]
      })
      if (this.options.changeWayType === 1) {
        // this.switchContent(index)
      }
    },
    mouseLeaveEv(index) {
      let _this = this
      this.hoverIndex = undefined
      const styleObj = this.defaultStyle
      Object.keys(styleObj).forEach(key => {
        if (index !== _this.options.activeIndex) {
          // _this.$refs.tab[index].style[key] = styleObj[key]
        }
      })
    },
    // 下拉框在控制其它组件的更新
    handleChartEvent(val) {
      const idStr = `container_id_${this.myid.container_id}-rect_id_${this.myid.rect_id}`
      const chartEventBus = window.chartEventBus
      if (chartEventBus && chartEventBus.eventMap[idStr]) {
        chartEventBus.dataMap[idStr] = val
        chartEventBus.emit(idStr)
      }
    },
    switchContent: function (index) {
      if (this.options.hasDataSource) return
      // todo 没有必要改变activeIndex来重新请求分类数据，直接通过tabList中保存的分类id（publicId）组装接口请求数据即可
      let oldActiveIndex = this.options.activeIndex
      if (this.options.activeIndex === index || this.options.changeWayType === 1) {
        return
      }
      const param = {
        ...this.myid,
        option_name: "value",
        option_val: this.tabLists[index].name
      }
      this.$changeOptionsEV(this.tabLists[index].name, "value", false, false, false, true)
      setTimeout(() => {
        if (this.isBigScreenPreview()) {
          this.$store.dispatch(this.request_prefix + "/changeTabsActiveIndex", {
            ...this.myid,
            activeIndex: index,
            singleTabs: this.options.singleTabs || false
          })
        } else {
          // 使用延时是为了 激活外层的vdr
          const tempIds = { ...this.ids }
          this.$store.commit("states/changeActiveID", tempIds)
          this.$store.dispatch(this.request_prefix + "/changeTabsActiveIndex", {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id,
            directionIndex: this.myid.directionIndex,
            elementInLayoutId: this.myid.elementInLayoutId,
            activeIndex: index,
            uid: this.myid.uid,
            singleTabs: this.options.singleTabs || false,
            isPageLayoutTabs: this.options.isPageLayoutTabs || false,
            elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
            parentRectId: this.options.parentRectId,
            path: this.myid.path,
          })
        }
        if (this.options.quoteFrom === "cxSelect") {
          // 引用下拉样式的时候 不调用鼠标悬浮样式
          return
        }
        this.mouseLeaveEv(oldActiveIndex)
        this.mouseoverEv(index)
      }, 10)
    },
    dbEditContent(event, index) {
      if (this.isBigScreenPreview() || this.noCacheComponent) {
        return
      }
      this.editIndex = index
      let oldActiveIndex = this.options.activeIndex
      if (this.options.activeIndex !== index) {
        return
      }
      this.isEditStatus = true
      sessionStorage.setItem("isEditStatus", true)
      this.activeIds = JSON.parse(JSON.stringify(this.ids))
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.ids, flag: false })
      this.$nextTick(() => {
        this.getSelectPos(index)
      })
    },
    // 将光标移动到最后面
    getSelectPos(index) {
      let esrc = this.$refs.tab[index]
      let range = document.createRange()
      range.selectNodeContents(esrc)
      range.collapse(false)
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    },
    dbChangeContent(event, index) {
      this.isEditStatus = false
      sessionStorage.removeItem("isEditStatus")
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.activeIds, flag: true })
      // let getTextContent = event.target.innerHTML.replace(/<[^>]+>/g, "<br>").replace(/(<br>)*$/g, "")
      let temp = JSON.parse(JSON.stringify(this.tabLists))
      // console.log(getTextContent)
      // temp[index].name = getTextContent
      // temp[index].name = getTextContent
      const params = {
        tabs: temp
      }
      let completeParam = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        data: params
      }
      this.$store.dispatch(this.request_prefix + "/initLayoutOthers", completeParam)
    },
    animateReloadFn() {
      if(!this.isBigScreenPreview()){
        return
      }
      let _self = this
      clearInterval(this.animateReloadTimer)
      if (!this.options.tabAutoChange) {
        return
      }
      this.animateReloadTimer = setInterval(() => {
        if (_self.options.activeIndex < _self.tabLists.length - 1) {
          try {
            _self.switchContent(_self.options.activeIndex + 1)
          } catch (e) {
           console.log(e)
          }
        } else {
          _self.switchContent(0)
        }
      }, this.options.autoChangeTime * 1000 || 10000)
    },
    getTabWidthList() {
      let list = this.$el.querySelectorAll(".tab")
      if (list.length > 1) {
        this.tabWidthList = []
        for (let i = 0; i < list.length; i++) {
          if (i === 0) {
            this.tabWidthList.push(Number(list[i].clientWidth))
          } else {
            this.tabWidthList.push(
              Number(list[i].clientWidth + (this.options.marginRight ? this.options.marginRight : 0))
            )
          }
        }
      }
    },
    //滚动展示被选中的选项
    scrollToSelected() {
      this.$nextTick(() => {
        if (this.activeIndex === 0) {
          this.$refs.tabs.scrollLeft = 0
        } else {
          let widthVal = 0
          for (let i = 0; i < this.activeIndex; i++) {
            widthVal += this.tabWidthList[i]
          }
          this.$refs.tabs.scrollLeft = widthVal
        }
        //此方案缺点：页面会跟着滚动
        // const selectedElement = this.$el.querySelector('.active');
        // if (selectedElement) {
        //    selectedElement.scrollIntoView({ behavior: 'smooth' });
        // }
      })
    },
    async updateData() {
      this.updateNormalRect.call(this, data => {
        console.log("updateCb111111", data)
        if (data.length) {
          let tabsList = []
          const { fieldFlag = "0", dataType, linkUrl } = this.currentFiledMapping
          data.forEach(item => {
            Object.keys(item).forEach((key, index) => {
              if (key === fieldFlag) {
                let value = ""
                switch (dataType) {
                  case "dataKey":
                    value = item[key].key + "：" + item[key].value
                    break
                  case "dataName":
                    value = item[key].key
                    break
                  default:
                    value = item[key].value
                    break
                }
                tabsList.push({
                  content: value,
                  name: value,
                  link: linkUrl ? item[linkUrl]?.value : ""
                })
              }
            })
          })
          this.$changeOptionsEV(tabsList, "tabsList", false)
        }
      })
    },
    // 重新组装搜索快捷入口的数据结构
    setFaskLinkData(datas) {
      const { appId } = this.layoutOptions
      if (this.dataType !== "3" || !appId || !this.searchComponentPlugin) return
      let tabsList = []
      if (datas && datas.length) {
        datas.forEach(item => {
          let value = item.name
          switch (this.options?.filedMapping?.dataType) {
            case "dataKey":
              value = "名称：" + item.name
              break
            case "dataName":
              value = "名称"
              break
            default:
              value = item.name
              break
          }
          const temp = {
            content: item.id,
            name: value,
            link: item.link,
            iconSrc: item.imgUrl,
            iconType: "img"
          }
          tabsList.push(temp)
        })
      }
      this.$changeOptionsEV(tabsList, "tabsList", false)
    },
  },
  destroyed() {
    clearInterval(this.animateReloadTimer)
    this.animateReloadTimer = null
    clearInterval(this.reloadTimer)
    this.reloadTimer = null
  },
  beforeDestroy() {
    this.$eventBus.$off(`searchDataUpdate-${this.myid.container_id}-${this.myid.rect_id}`)
  }
}
</script>

<style scoped>
.tabsContainer {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: left;
}
.tabsContainer.scroller::-webkit-scrollbar {
  display: block; /* Chrome Safari */
}
.tab {
  position: relative;
  display: inline-block;
  vertical-align: top;
  /*float: left;*/
  /*box-sizing: content-box;*/
}
.tabsContainer .tab:last-child {
  margin-right: 0 !important;
}
.tab .tab-underline {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
.edit-input {
  background-color: transparent;
  width: var(--ultimate-Width);
  text-align: center;
  color: inherit;
  font-size: inherit;
}
::v-deep svg {
  vertical-align: middle;
}
.inline {
  display: inline-block;
  vertical-align: top;
  /* line-height: 1; */
}
.hideScrollBar_AutoScroll {
  white-space: nowrap;
  overflow-x: auto;
}
.tabsContainer.scroller.hideScrollBar_AutoScroll::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.vertical-middle{
  vertical-align: middle;
  line-height: 1;
  font-size:0
}
/* 文本内容不允许换行 */
.nowrap .tab .tab-name > span {
  white-space: nowrap;
}
.divide-box {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: var(--divideMargin);
}
.divide-box .line,
.divide-box .icon {
  display: block;
}
.overflowHidMultiLines {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
